<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import {getUrlKey} from "@/utils/utils";
import {getWxUser} from "@/api/wx_user";
import {setToken} from "@/utils/auth";

export default {
  name: 'App',

  data(){
    return {
      isRouterAlive:true
    }
  },
  provide(){
    return {
      reload:this.reload
    }
  },
  created() {
    // let code = getUrlKey("code",window.location.href)
    // getWxUser({code:code}).then(res =>{
    //   setToken(res.data)
    // })
  },
  methods:{
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function (){
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue